import { fixedTwoFractionDigitsExceptIntegerCurrencyOptions } from 'constants/loanApplication';
import { checkIsHelocLoanType } from 'utils/loanApplication';
import { formatNumberToCurrencyString, formatNumberToFixed2DecimalsMax } from 'utils/number';

import { ADDITIONAL_LOAN_NAME } from './Chart.constants';

const GET_PERCENTAGE_VALUE = 100;

export const getCurrencyValue = value =>
  formatNumberToCurrencyString(value ?? 0, fixedTwoFractionDigitsExceptIntegerCurrencyOptions);

export const getPercentageValue = value =>
  `${formatNumberToFixed2DecimalsMax(value * GET_PERCENTAGE_VALUE)}%`;

export const getLtvName = (ltv, cltv, hltv) => {
  if (ltv === cltv && ltv === hltv) {
    return 'LTV/CLTV/HLTV';
  }

  if (ltv === cltv && ltv !== hltv) {
    return 'LTV/CLTV';
  }

  if (ltv !== hltv && ltv !== cltv) {
    return 'LTV';
  }
};

export const getTotalLoanAmountName = (loanType, isAssociatedWithFirstLien) => {
  if (!checkIsHelocLoanType(loanType)) {
    return 'Total Loan Amount';
  }

  return isAssociatedWithFirstLien ? 'First Lien' : 'HELOC Draw';
};

export const getAdditionalLoanName = loanType => {
  if (!checkIsHelocLoanType(loanType)) {
    return ADDITIONAL_LOAN_NAME;
  }

  return 'HELOC Available Credit';
};
